// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IOrganizationLogoDto } from './IOrganizationLogoDto';
import {
    IOrganizationLogoDtoFromJSON,
    IOrganizationLogoDtoFromJSONTyped,
    IOrganizationLogoDtoToJSON,
    IOrganizationLogoDtoToJSONTyped,
} from './IOrganizationLogoDto';

/**
 * 
 * @export
 * @interface IExpressSetupInfoDto
 */
export interface IExpressSetupInfoDto {
    /**
     * 
     * @type {boolean}
     * @memberof IExpressSetupInfoDto
     */
    enable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupInfoDto
     */
    partner_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupInfoDto
     */
    pricing_consent?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupInfoDto
     */
    terms_and_conditions_link?: string;
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupInfoDto
     */
    privacy_policy_link?: string;
    /**
     * 
     * @type {IOrganizationLogoDto}
     * @memberof IExpressSetupInfoDto
     */
    logo_info?: IOrganizationLogoDto;
}

/**
 * Check if a given object implements the IExpressSetupInfoDto interface.
 */
export function instanceOfIExpressSetupInfoDto(value: object): value is IExpressSetupInfoDto {
    return true;
}

export function IExpressSetupInfoDtoFromJSON(json: any): IExpressSetupInfoDto {
    return IExpressSetupInfoDtoFromJSONTyped(json, false);
}

export function IExpressSetupInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'enable': json['enable'] == null ? undefined : json['enable'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'pricing_consent': json['pricing_consent'] == null ? undefined : json['pricing_consent'],
        'terms_and_conditions_link': json['terms_and_conditions_link'] == null ? undefined : json['terms_and_conditions_link'],
        'privacy_policy_link': json['privacy_policy_link'] == null ? undefined : json['privacy_policy_link'],
        'logo_info': json['logo_info'] == null ? undefined : IOrganizationLogoDtoFromJSON(json['logo_info']),
    };
}

export function IExpressSetupInfoDtoToJSON(json: any): IExpressSetupInfoDto {
    return IExpressSetupInfoDtoToJSONTyped(json, false);
}

export function IExpressSetupInfoDtoToJSONTyped(value?: IExpressSetupInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enable': value['enable'],
        'partner_name': value['partner_name'],
        'pricing_consent': value['pricing_consent'],
        'terms_and_conditions_link': value['terms_and_conditions_link'],
        'privacy_policy_link': value['privacy_policy_link'],
        'logo_info': IOrganizationLogoDtoToJSON(value['logo_info']),
    };
}

